<template>
  <div>
    <div class="row mt-3 ml-sm-4 pl-sm-2">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-file-search text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Documentos de la Solicitud
        </span>
      </div>
    </div>
    <custom-result-not-found
      v-if="items.length === 0"
      text="La solicitud no cuenta con documentos asociados en sistema."
    />
    <div v-for="(data, index) in items" :key="index">
      <custom-callout
        class-main=" mt-3 border-0 ml-sm-5"
        :has-border="false"
        :has-gradient="false"
        :has-toggle="false"
      >
        <div class="row mr-md-0">
          <div class="col col-sm-3">
            <div class="color-gray-6 font-14">Tipo de Documento:</div>
            <div class="color-black font-16">
              {{ data.documentTypeDesc | empty }}
            </div>
          </div>
          <div class="col col-sm">
            <div class="color-gray-6 font-14">Nombre del Archivo:</div>
            <div class="color-black font-16">
              {{ data.attachment.name | empty }}
            </div>
          </div>
          <div class="col col-sm text-sm-right mt-3 mt-sm-1">
            <action-button
              i="fas fa-file-download mr-n1 pr-1"
              variant="success"
              @click="$emit('on-download-document', data)"
            />
          </div>
        </div>
      </custom-callout>
    </div>
  </div>
</template>
<script>
import CustomCallout from 'custom-callout';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';

export default {
  name: 'RequestDocument',
  components: {
    CustomCallout,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
